var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-wrap",class:{[_vm.deviceClass]: 1},style:(_vm.style)},[_c('portal-target',{attrs:{"name":"destination"}}),_vm._v(" "),_c('nuxt',{staticClass:"h-full",on:{"change-style":_vm.changeStyle}}),_vm._v(" "),_c('coupon-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }